import React from 'react'; 
import MainHeader from '../../components/MainHeader';
import Programs from '../../components/Programs';
import Values from '../../components/Values';
import FAQs from '../../components/FAQs';
import Testimonials from '../../components/Testimonials';

import './home.css';

const Home = () => {
    return (
        <>
            <div className="section main-header-section">
                <MainHeader />
            </div>

            <div className="section programs-section">
                <Programs />
            </div>

            <div className="section values-section">
                <Values />
            </div>

            <div className="section faqs-section">
                <FAQs />
            </div>

            <div className="section testimonials-section">
                <Testimonials />
            </div>
        </>
    );
};

export default Home;
